import { ReactElement } from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useRouter } from 'next/router';

import Onboarding from 'components/candidate/Onboarding';
import { getLayout } from 'components/layouts/Header';
import { withAuthCandidate } from 'lib/hocs/withAuthCandidate';

import styles from './Onboarding.module.scss';

const Onboardingpage = (): ReactElement => {
  const router = useRouter();
  const { matching_preference } = router.query;

  return (
    <>
      <Head>
        <title>{matching_preference ? 'Preferences | Huzzle' : 'Onboarding | Huzzle'}</title>
        <meta name="description" content="Huzzle" />
      </Head>

      <section className={styles.Onboardingpage} data-testid="Onboarding">
        <Onboarding isMatchingPreferences={matching_preference === 'true'} />
      </section>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'candidate-dashboard', 'candidate-onboarding'])),
    },
  };
}

const OnboardingWrapper = withAuthCandidate(Onboardingpage);
// @ts-ignore
OnboardingWrapper.getLayout = getLayout;

export default OnboardingWrapper;
